import React from 'react';
import {
  ControllerProps,
  FieldValues,
  Path,
  UseControllerReturn,
  UseControllerProps,
} from 'react-hook-form';
import { DesktopDatePickerProps, DesktopDatePicker } from '@mui/x-date-pickers';
import { TextField, TextFieldProps } from '@mui/material';

import { makeControlledInput } from './makeControlledInput';

export const mapControllerDatePicker = <
  TInputDate,
  TDate = TInputDate,
  TFieldValues extends FieldValues = FieldValues,
  TName extends Path<TFieldValues> = Path<TFieldValues>
>(
  { field, fieldState }: UseControllerReturn<TFieldValues, TName>,
  _controllerProps?: Omit<ControllerProps<TFieldValues, TName>, 'render'>,
  inputProps?: Partial<DesktopDatePickerProps<TInputDate, TDate>>
): DesktopDatePickerProps<TInputDate, TDate> => ({
  ...inputProps,
  value: field.value,
  onChange: field.onChange,
  inputRef: field.ref,
  renderInput: (params: TextFieldProps) => (
    <TextField {...params} error={params.error || Boolean(fieldState.error)} />
  ),
});

export const controlledDatePicker =
  <TFieldValues extends FieldValues = FieldValues>() =>
  <
    TDefaultControllerProps extends Partial<UseControllerProps<TFieldValues, TName>>,
    TName extends Path<TFieldValues>
  >(
    name: TName,
    defaultControllerProps?: TDefaultControllerProps
  ) =>
    makeControlledInput<TFieldValues>()({
      name,
      defaultControllerProps,
      Component: DesktopDatePicker,
      propsMapper: mapControllerDatePicker,
    });
